import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { Divider } from '../Divider';
import { AntdButton } from '../Button/Button';

import { colors } from '../../styles/colors/';

const Text = styled.span`
  line-height: 20px;
  font-size: 16;
  color: ${colors.gray[8]};
`;

const Title = styled(Text)`
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: ${colors.gray[9]};
  display: block;
  margin-bottom: 8px;
`;

const SubTitle = styled(Text)`
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  display: block;
  margin-bottom: 4px;
`;

const TitleBuffer = styled.div`
  margin-bottom: 8px;
`;

const Button = styled(AntdButton)`
  margin-top: 40px;

  ${(props) =>
    props.buttonColor &&
    css`
      ${(props) => (props.type === 'primary' ? 'background-color' : 'color')}: ${props.buttonColor};
      border: 1px solid ${props.buttonColor};
    `}
`;

const Summary = ({
  title,
  subTitle,
  divider,
  buttonColor,
  buttonText,
  buttonOnClick,
  buttonType,
  buttonLoading,
  disabled,
  ...props
}) => {
  return (
    <React.Fragment>
      {title && <Title>{title}</Title>}
      {divider && <Divider style={{ marginBottom: '16px', marginTop: 0 }} />}
      {title && !divider && <TitleBuffer />}
      {subTitle && <SubTitle>{subTitle}</SubTitle>}
      {props.children}
      {buttonText && (
        <Button
          type={buttonType}
          label={buttonText}
          onClick={buttonOnClick}
          buttonColor={buttonColor}
          loading={buttonLoading}
          disabled={disabled}
        />
      )}
    </React.Fragment>
  );
};

Summary.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  divider: PropTypes.bool,
  buttonColor: PropTypes.string,
  buttonText: PropTypes.string,
  buttonOnClick: PropTypes.func,
  buttonType: PropTypes.string,
  buttonLoading: PropTypes.bool,
  disabled: PropTypes.bool,
};

Summary.defaultProps = {
  divider: false,
};

export { Summary };
